<template><section><h2>Challenge Descriptions</h2>
<p>The setting for the 2012 VAST Challenges is BankWorld, a planet much like Earth, but with a very different geography. In fact, for this Challenge, we are dealing with one large land mass containing several different nation-states.</p>
<p>The most important organization on BankWorld is the Bank of Money (BOM). BOM has many offices of various sizes across BankWorld. Each of these offices has many computers active throughout the day. In fact, we are dealing with about 1,000,000 machines.</p>
<p>The Bank of Money (BOM) Corporate Information Officer (CIO) has assigned you to create a situation awareness visualization of the entire enterprise. This is a considerable challenge, considering that BOM operates from BankWorld's coast to coast. In addition to observing the global situation, he would also would like to be able to detect operational changes outside of the norm.</p>
<p>You are provided with two datasets that span two days of data for BOM.
One dataset contains metadata about the bank’s network.
The second dataset contains periodic status reports from all computing equipment in the BOM enterprise.</p>
<p>There is also one additional smaller dataset that contains a one hour snapshot of the enterprise's activities. It has the same format as the second dataset mentioned above, and can use the metadata contained in the first dataset.</p>
<h2>Project Task</h2>
<ul>
<li>
<p>Create a visualization of the health and policy status of the entire Bank of Money enterprise as of 2 pm BMT (BankWorld Mean Time) on February 2. What areas of concern do you observe?</p>
</li>
<li>
<p>Use your visualization tools to look at how the network’s status changes over time. Highlight up to five potential anomalies in the network and provide a visualization of each. When did each anomaly begin and end? What might be an explanation of each anomaly?</p>
</li>
</ul>
<h2>Schedule</h2>
<ul>
<li>
<p>Fetch Dataset, analyse tasks, and make a plan to solve it (2-3 week)</p>
</li>
<li>
<p>Process data, implement analysis framework (4-7 week)</p>
</li>
<li>
<p>Mid-term inspection (8 week)</p>
</li>
<li>
<p>Implement analysis system (9-12 week)</p>
</li>
<li>
<p>Inter-team evaluation and modification (13-15 week)</p>
</li>
<li>
<p>Final inspection (16-17 week)</p>
</li>
</ul>
<h2>Resources</h2>
<ul>
<li>http://www.vacommunity.org/VAST+Challenge+2012%3A+Challenge+Descriptions</li>
</ul>
</section></template><script>export default {components:{}}</script>